import { useState, useEffect, useCallback } from "react";
import { verifyToken } from "../axios/login";
import { performSessionLogout } from "../utils/sessionLogout";
import { getAuthToken } from "../utils/authToken";

export const useVerifyToken = () => {
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const checkToken = useCallback(async () => {
    const token = getAuthToken();

    if (!token) {
      setIsValid(false);
      setMessage("Token is missing");
      return;
    }

    if (!navigator.onLine) {
      setIsValid(true);
      return;
    }

    try {
      const result = await verifyToken(token);

      if (result.valid) {
        setIsValid(true);
        setMessage("Token is valid");
      } else {
        setIsValid(false);
        setMessage(result.message || "Invalid token");
        void performSessionLogout();
      }
    } catch {
      // Network/server unreachable — keep cached session (e.g. offline reload)
      setIsValid(true);
    }
  }, []);

  useEffect(() => {
    checkToken();
  }, [checkToken]);

  return { isValid, message, checkToken };
};
